import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeCourrierComponent } from './private/DASHBOARD/home-courrier/home-courrier.component';
import { HomeCourrierChildComponent } from './private/DASHBOARD/home-courrier-child/home-courrier-child.component';
import { HomeActionComponent } from './private/ACTIONS/home-action/home-action.component';
import { AssistanceComponent } from './private/assistance/assistance.component';
import { PrivateComponent } from './private/private/private.component';
import { PublicComponent } from './public/public/public.component';
import { HomeComponent } from './public/public/home/home.component';
import { HomePrivateComponent } from './private/home/home.component';
import { SignatureCallbackComponent } from './public/public/signature-callback/signature-callback.component';
import { ContactsComponent } from './private/CONTACT/contacts/contacts.component';
import { CourrierCreateComponent } from './private/COURRIER-S/courrier-create/courrier-create.component';
import { Page401Component } from './public/page401/page401.component';
import { ContactPictureComponent } from './private/CONTACT/contact-picture/contact-picture.component';
import { ContactDetailsComponent } from './private/CONTACT/contact-details/contact-details.component';
import { ContactEditionComponent } from './private/CONTACT/contact-edition/contact-edition.component';
import { ConfirmDeactivateGuard } from './guards/confirm-deactivate.guard';
import { CourrierDetailsComponent } from './private/COURRIER-E/courrier-details/courrier-details.component';
import { CourrierForTabsComponent } from './private/COURRIER-E/courrier-for-tabs/courrier-for-tabs.component';
import { CourrierDeactivateGuard } from './guards/courrier-deactivate.guard';
import { DocumentEditorByFileIdComponent } from './private/COURRIER-S/document-editor-by-file-id/document-editor-by-file-id.component';
import { DocumentToValidateComponent } from './private/DASHBOARD/home-courrier/document-to-validate/document-to-validate.component';
import { DocumentToSignComponent } from './private/DASHBOARD/home-courrier/document-to-sign/document-to-sign.component';
import { ProfilComponent } from './private/profil/profil.component';
import { CourrierExchangeComponent } from './private/COURRIER-E/courrier-exchange/courrier-exchange.component';
import { ReportingComponent } from './private/reporting/reporting.component';
import { LockedCourriersComponent } from './private/locked-courriers/locked-courriers.component';
import { CreationCourrierComponent } from './components/creation-courrier/creation-courrier.component';
import { FileviewerComponent } from './private/fileviewer/fileviewer.component';
import { PersonalParamsComponent } from './private/profil/personal-params/personal-params.component';
import { AdvSearchComponent } from './private/adv-search/adv-search.component';
import { msalConfig } from './private/COURRIER-E/courrier-365/msal/auth-config';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { HomeIscanComponent } from './components/iscanV2/home-iscan/home-iscan.component';
import { DetailsScanComponent } from './components/iscanV2/details-scan/details-scan.component';
import { ConfirmDeactivateScanGuard } from './guards/confirm-deactivate-scan.guard';
import { NotificationsComponent } from './private/profil/notifications/notifications.component';
import { SignatureComponent } from './private/profil/signature/signature.component';
import { CallbackComponent } from '@devinforius/i-sso';
import { AuthRedirectGuard } from './guards/auth-redirect.guard';

const routes: Routes = [
  {
    path: 'myhome',
    component: HomePrivateComponent,
    canActivate: [AuthRedirectGuard],
  },
  {
    path: 'private/ic',
    component: PrivateComponent,
    canActivate: [AuthRedirectGuard],
    children: [
      //* Routes to the profil located in the toothed wheel  in the sidebar
      {
        path: 'profil',
        component: ProfilComponent,
        children: [
          {
            path: 'personal-params',
            component: PersonalParamsComponent,
          },
          {
            path: 'notifications',
            component: NotificationsComponent,
          },
          {
            path: 'signature',
            component: SignatureComponent,
          },
        ],
      },
      {
        path: 'tabs/:id',
        component: CourrierForTabsComponent,
      },
      {
        path: 'document/to-validate',
        component: DocumentToValidateComponent,
      },
      {
        path: 'document/to-sign',
        component: DocumentToSignComponent,
      },
      {
        path: 'courriers',
        component: HomeCourrierComponent,
      },
      {
        path: 'reporting',
        component: ReportingComponent,
      },
      {
        path: 'courriers-365-home',
        loadChildren: () => import('./private/COURRIER-E/courrier-365/courrier-365.module').then((module) => module.Courrier365Module),
      },
      {
        path: msalConfig.auth.redirectUri?.substring(1) ?? 'courriers-365',
        component: MsalRedirectComponent,
      },
      {
        path: 'courriers-exchange',
        component: CourrierExchangeComponent,
      },
      {
        path: 'locked/courriers',
        component: LockedCourriersComponent,
      },
      {
        path: 'courriers/:title',
        component: HomeCourrierChildComponent,
        children: [
          {
            path: ':id',
            component: CourrierDetailsComponent,
            data: { contacts: [] },
          },
          {
            path: ':id/fullscreen',
            component: CourrierDetailsComponent,
          },
        ],
      },
      {
        path: 'new',
        component: CreationCourrierComponent,
      },
      {
        path: 'new-from-idelibe',
        component: CreationCourrierComponent,
      },
      {
        path: 'new/:mailId',
        component: CourrierCreateComponent,
        canDeactivate: [CourrierDeactivateGuard],
      },
      {
        path: 'new-mail',
        component: CourrierCreateComponent,
        canDeactivate: [CourrierDeactivateGuard],
      },
      {
        path: 'editor/:mailId/file/:fileId',
        component: DocumentEditorByFileIdComponent,
        canDeactivate: [CourrierDeactivateGuard],
      },
      {
        path: 'newSc/:newMailLotScanGuid/newCourrier',
        component: CourrierCreateComponent,
        canDeactivate: [CourrierDeactivateGuard],
      },
      {
        path: 'newSc/:newMailLotScanGuid/duplicateRecent/:newMailScanDuplicateMailId',
        component: CourrierCreateComponent,
        canDeactivate: [CourrierDeactivateGuard],
      },

      {
        path: 'actions',
        data: { title: 'actions', icon: 'icon-rocket', navMenu: true },
        component: HomeActionComponent,
      },
      {
        path: 'contacts',
        component: ContactsComponent,
        // ,canDeactivate: [PendingChangesGuard]
        children: [
          {
            path: '',
            component: ContactPictureComponent,
          },
          {
            path: ':id',
            component: ContactEditionComponent,
            canDeactivate: [ConfirmDeactivateGuard],
          },
          // {
          //   path: 'new', component: ContactEditionComponent, canDeactivate: [ConfirmDeactivateGuard]
          // },
          {
            path: 'details/:id',
            component: ContactDetailsComponent,
          },
        ],
      },
      {
        path: 'advSearch',
        component: AdvSearchComponent,
      },
      {
        path: 'assistance',
        component: AssistanceComponent,
      },
      {
        path: 'home-scans',
        component: HomeIscanComponent,
        canDeactivate: [ConfirmDeactivateScanGuard],
      },
      {
        path: 'iscan/detail/:id',
        component: DetailsScanComponent,
        canDeactivate: [ConfirmDeactivateScanGuard],
      },
      {
        path: 'file-viewer',
        component: FileviewerComponent,
      },
    ],
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: '401',
        component: Page401Component,
      },
      {
        path: '**',
        redirectTo: 'home',
      },
    ],
  },

  {
    path: 'signature',
    component: SignatureCallbackComponent,
  },
  {
    path: '**',
    redirectTo: 'public',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
